<template>
    <div id="sender-form">
        <drawer
            ref="senderDrawer"
            :startsOpen="false"
            :hasHeader="false"
            id="senderDrawer"
            @hide="$emit('close')"
        >
            <template slot="title">
            </template>
            <template slot="body">
                <KvTabs v-model="activeTab">
                    <template #tabs>
                        <KvTab value="details">{{ t('settings-connections-sender_form-details_tab') }}</KvTab>
                        <KvTab value="settings">{{ t('settings-connections-sender_form-settings_tab') }}</KvTab>
                    </template>
                    <template #panels>
                        <KvTabPanel value="details">
                            <div>
                                <KvTypography variant="div" size="small" weight="semibold" title>
                                    {{ t('settings-connections-sender_form-adding_connection') }}
                                </KvTypography>
                                <h2 class="d-flex align-items-center gap-sm mt-2">
                                    <img v-if="senderImageSrc" :src="senderImageSrc" height="36" />
                                    <KvTypography variant="div" size="large" weight="medium" title>
                                        <span>{{ sender.title }}</span>
                                    </KvTypography>
                                </h2>
                            </div>
                            <hr class="my-4" />
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="bg-black-50 rounded-lg border-black-100 p-3">
                                        <div class="d-flex align-items-center">
                                            <div class="circle bg-brand-green-100 h-8 w-8 mr-1 d-flex justify-content-center align-items-center">
                                                <Icon icon-class="ui-check" size="3" color="brand-green-500" />
                                            </div>
                                            <KvTypography variant="div" size="small" weight="semibold" title color="brand-green-500">
                                                {{ t('settings-connections-sender_form-connection_cost') }}
                                            </KvTypography>
                                        </div>
                                        <div class="bg-white border-black-100 rounded-sm p-3 mt-3">
                                            <KvTypography variant="div" size="small" color="black-500"> {{ t('settings-connections-sender_form-monthly_subscription') }}</KvTypography>
                                            <KvTypography variant="div" size="large" title color="utility-success-500" class="mt-2"> R$ {{ sender.sender_price }}</KvTypography>
                                        </div>
                                        <KvTypography variant="div" size="extra-small" color="black-500" title class="mt-2"> {{ t('settings-connections-sender_form-connection_valid_per_phone') }}</KvTypography>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="bg-black-50 rounded-lg border-black-100 p-3">
                                        <div class="d-flex align-items-center">
                                            <div class="circle bg-brand-green-100 h-8 w-8 mr-1 d-flex justify-content-center align-items-center">
                                                <Icon icon-class="ui-check" size="3" color="brand-green-500" />
                                            </div>
                                            <KvTypography variant="div" size="small" weight="semibold" title color="brand-green-500">
                                                {{ t('settings-connections-sender_form-credit_cost') }}
                                            </KvTypography>
                                        </div>
                                        <div class="bg-white border-black-100 rounded-sm p-3 mt-3">
                                            <div class="d-flex align-items-center">
                                                <KvTypography variant="div" size="small" title color="utility-success-500" class="mr-1"> 0,2 </KvTypography>
                                                <KvTypography variant="div" size="extra-small" color="black-500"> {{ t('settings-connections-sender_form-per_message_sent') }}</KvTypography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="what-you-need-to-know mt-4">
                                <div class="d-flex align-items-center justify-content-between mb-2">
                                    <h2 class="mb-0">{{ t('settings-connections-sender_form-what_you_need_to_know') }}</h2>
                                    <KvButton 
                                        v-if="isGlobalAdmin" 
                                        @click="openEditBodyModal"
                                        size="small"
                                        variant="outlined"
                                    >
                                        {{ t('settings-connections-sender_form-edit') }}
                                    </KvButton>
                                </div>
                                <div class="body-content" v-html="senderBody"></div>
                                <div class="d-flex justify-content-end gap-sm">
                                    <KvButton 
                                        @click="close"
                                        variant="outlined"
                                    >
                                        {{ t('settings-connections-sender_form-close') }}
                                    </KvButton>
                                    <KvButton 
                                        @click="activeTab = 'settings'"
                                    >
                                        {{ action == 'add' ? t('settings-connections-sender_form-install_connection') : t('settings-connections-sender_form-edit_settings') }}
                                    </KvButton>
                                </div>
                            </div>
                        </KvTabPanel>
                        <KvTabPanel value="settings">
                            <div class="d-flex align-items-center justify-content-center">
                                <h2 class="d-flex align-items-center gap-sm">
                                    <img v-if="senderImageSrc" :src="senderImageSrc" height="36" />
                                    {{ sender.title }}
                                </h2>
                            </div>
                            <edit-whatsapp 
                                v-if="sender.channel == 'whatsapp'" 
                                :place_sender="place_sender"
                                :sender="sender"
                                @saved="saved"
                                @done="done"
                            />
                            <edit-sms 
                                v-if="sender.channel == 'sms'" 
                                :sender="sender"
                                :senders="senders"
                                :rawEditing="place_sender"
                                @saved="saved"
                                @done="done"
                            />
                            <edit-rcs
                                v-if="sender.channel == 'rcs'"
                                :sender="sender"
                                :senders="senders"
                                :rawEditing="place_sender"
                                @saved="saved"
                                @done="done"
                            />
                            <edit-email 
                                v-if="sender.channel == 'email'" 
                                :sender="sender"
                                :senders="senders"
                                :rawEditing="place_sender"
                                @saved="saved"
                                @done="done"
                            />
                            <edit-whatsapp-cloud 
                                v-if="sender.channel == 'whatsapp-cloud'" 
                                :sender="sender"
                                :senders="senders"
                                :rawEditing="place_sender"
                                @saved="saved"
                                @done="done"
                            />

                            <!-- Configuration Instructions Section -->
                            <div class="instructions-section mt-4" v-if="configurationInstructions">
                                <div class="box box-secondary bg-black-50">
                                    <div class="title-container d-flex align-items-center justify-content-between">
                                        <KvTypography size="small" weight="semibold" color="black-600" title>{{ t('settings-connections-sender_form-configure_how') }}</KvTypography>
                                        <KvButton 
                                            v-if="isGlobalAdmin" 
                                            @click="openEditInstructionsModal"
                                            size="small"
                                            variant="outlined"
                                        >
                                            {{ t('settings-connections-sender_form-edit_instructions') }}
                                        </KvButton>
                                    </div>
                                    <div class="text-xs instructions-content" v-html="configurationInstructions"></div>
                                </div>
                            </div>
                        </KvTabPanel>
                    </template>
                </KvTabs>
            </template>
        </drawer>

        <!-- Modal for editing sender body -->
        <KvModal size="large" :modelValue="showEditBodyModal" @update:modelValue="showEditBodyModal = $event">
            <template #title>{{ t('settings-connections-sender_form-edit_sender_description') }}</template>
            <template #subtitle>{{ t('settings-connections-sender_form-format_help') }}</template>

            <template #body>
                <KvEditor 
                    v-model="bodyEditorValue" 
                    :placeholder="t('settings-connections-sender_form-description_placeholder')" 
                    height="350px"
                />
            </template>

            <template #footer="{ toggle }">
                <KvButton variant="outlined" @click="toggle">{{ t('settings-connections-sender_form-cancel') }}</KvButton>
                <KvButton 
                    prepend-icon="ui-check" 
                    @click="saveBody(toggle)" 
                    :loading="savingBody"
                >
                    {{ t('settings-connections-sender_form-save') }}
                </KvButton>
            </template>
        </KvModal>

        <!-- Modal for editing configuration instructions -->
        <KvModal size="large" :modelValue="showEditInstructionsModal" @update:modelValue="showEditInstructionsModal = $event">
            <template #title>{{ t('settings-connections-sender_form-edit_configuration_instructions') }}</template>
            <template #subtitle>{{ t('settings-connections-sender_form-format_help') }}</template>

            <template #body>
                <KvEditor 
                    v-model="instructionsEditorValue" 
                    :placeholder="t('settings-connections-sender_form-instructions_placeholder')" 
                    height="350px"
                />
            </template>

            <template #footer="{ toggle }">
                <KvButton variant="outlined" @click="toggle">{{ t('settings-connections-sender_form-cancel') }}</KvButton>
                <KvButton 
                    prepend-icon="ui-check" 
                    @click="saveInstructions(toggle)" 
                    :loading="savingInstructions"
                >
                    {{ t('settings-connections-sender_form-save') }}
                </KvButton>
            </template>
        </KvModal>
    </div>
</template>
<script>
import EditWhatsapp from "./whatsapp.vue";
import EditSms from "./sms.vue";
import EditRcs from "./rcs.vue";
import EditEmail from "./email.vue";
import EditWhatsappCloud from "./whatsapp-cloud.vue";
import KvTypography from "@/components/ui/kv-typography.vue";
import KvTabs from "@/components/tabs/kv-tabs.vue";
import KvTab from "@/components/tabs/kv-tab.vue";
import KvTabPanel from "@/components/tabs/kv-tab-panel.vue";
import KvModal from "@/components/modal/modal.vue";
import KvEditor from "@/components/inputs/kv-editor.vue";
import KvButton from "@/components/form/kv-button.vue";
import keviApi from "@/keviApi";

export default {
    components: { 
        EditWhatsapp, 
        EditSms, 
        EditRcs, 
        EditEmail, 
        EditWhatsappCloud, 
        KvTypography, 
        KvTabs, 
        KvTabPanel, 
        KvTab,
        KvModal,
        KvEditor,
        KvButton,
    },
    props: {
        sender: {
            type: Object,
            required: true,
        },
        place_sender: {
            type: Object,
            required: true,
        },
        senders: {
            type: Array,
            default: () => [],
        },
        action: {
            type: String,
            default: 'edit',
            validator: function (value) {
                return ['edit', 'add'].includes(value);
            },
        },
    },
    data() {
        return {
            activeTab: this.action == 'add' ? 'details' : 'settings',
            // Body editing
            showEditBodyModal: false,
            bodyEditorValue: { html: '', text: '', empty: true },
            savingBody: false,
            localSenderBody: null,
            // Instructions editing
            showEditInstructionsModal: false,
            instructionsEditorValue: { html: '', text: '', empty: true },
            savingInstructions: false,
            configurationInstructions: this.sender?.configuration_instructions || this.$_('settings-connections-sender_form-default_instructions'),
        };
    },
    computed: {
        isGlobalAdmin() {
            return this.$store.state.user?.global_admin;
        },
        senderImageSrc() {
            const name = this.sender?.name;
            if (!name) return null;
            return `/images/senders/${name}.png`;
        },
        senderBody() {
            return this.localSenderBody ?? this.sender?.body ?? this.$_('settings-connections-sender_form-default_body');
        },
    },
    methods: {
        open() {
            this.$refs.senderDrawer.open();
        },
        close() {
            this.$refs.senderDrawer.close();
        },
        saved(sender) {
            this.$emit('saved', sender);
        },
        done() {
            this.$emit('done');
        },
        // Body modal methods
        openEditBodyModal() {
            this.bodyEditorValue = { 
                html: this.senderBody, 
                text: '', 
                empty: false 
            };
            this.showEditBodyModal = true;
        },
        async saveBody(toggleModal) {
            if (!this.bodyEditorValue || !this.bodyEditorValue.html) return;

            this.savingBody = true;

            try {
                const options = keviApi.getOptions(`senders/${this.sender.id}/body`, "POST", {
                    body: this.bodyEditorValue.html,
                });
                const response = await this.$http(options);
                this.localSenderBody = response.body.sender.body;
                this.$store.dispatch('notification/success', this.$_('settings-connections-notifications-description_saved_success'));
                this.showEditBodyModal = false;
            } catch (err) {
                this.$store.dispatch(
                    'notification/warning',
                    this.$_('settings-connections-notifications-description_save_error', [err.body?.message || this.$_('settings-connections-notifications-unknown_error')]),
                );
            } finally {
                this.savingBody = false;
            }
        },
        // Instructions modal methods
        openEditInstructionsModal() {
            this.instructionsEditorValue = { 
                html: this.configurationInstructions, 
                text: '', 
                empty: false 
            };
            this.showEditInstructionsModal = true;
        },
        async saveInstructions(toggleModal) {
            if (!this.instructionsEditorValue || !this.instructionsEditorValue.html) return;

            this.savingInstructions = true;

            try {
                const options = keviApi.getOptions(`senders/${this.sender.id}/configuration-instructions`, "POST", {
                    configuration_instructions: this.instructionsEditorValue.html,
                });
                const response = await this.$http(options);
                this.configurationInstructions = response.body.sender.configuration_instructions;
                this.$store.dispatch('notification/success', this.$_('settings-connections-notifications-instructions_saved_success'));
                this.showEditInstructionsModal = false;
            } catch (err) {
                this.$store.dispatch(
                    'notification/warning',
                    this.$_('settings-connections-notifications-instructions_save_error', [err.body?.message || this.$_('settings-connections-notifications-unknown_error')]),
                );
            } finally {
                this.savingInstructions = false;
            }
        },
    },
    watch: {
        sender: {
            handler(newSender) {
                this.localSenderBody = newSender?.body || null;
                this.configurationInstructions = newSender?.configuration_instructions || this.$_('settings-connections-sender_form-default_instructions');
                this.activeTab = this.action == 'add' ? 'details' : 'settings';
            },
            immediate: true,
        },
    },
}
</script>
<style lang="less" scoped>
#sender-form {
    .what-you-need-to-know {
        h2 {
            font-size: 16px;
            font-weight: 600;
            color: #1F2A37;
        }

        .body-content {
            font-size: 14px;
            line-height: 1.6;
            color: #6C737F;

            :deep(p) {
                margin: 0 0 8px 0;
            }

            :deep(ul), :deep(ol) {
                margin: 8px 0;
                padding-left: 24px;
            }

            :deep(li) {
                margin: 4px 0;
            }

            :deep(strong) {
                font-weight: 600;
                color: #384250;
            }

            :deep(a) {
                color: #1570EF;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .instructions-section {
        .box {
            padding: 20px;
        }

        .instructions-content {
            :deep(p) {
                margin: 0 0 4px 0;
            }
        }
    }
}
</style>
